import React from 'react';
import UploadField from '../../UploadField/UploadField';
import { fieldNames } from '../constants';
import { fileSizeValidator } from '../../../../utils/fileSizeValidator';
import { maxFileSize } from '../../../../../../constants/maxFileSize';

const UploadFiles = ({ form, disabled }) => {
  const handleChange = (info) => {
    if (info.fileList?.length) {
      const newFileList = info.fileList.map((file) => {
        if (file.size > maxFileSize) {
          file.status = 'error';
        }
        return file;
      });
      form.setFieldsValue({ [fieldNames.files]: newFileList });
    }
  };

  return (
    <UploadField
      disabled={disabled}
      form={form}
      name={fieldNames.files}
      label="Вложения"
      uploadProps={{ multiple: true, onChange: handleChange }}
      rules={[
        {
          validator: fileSizeValidator,
        },
      ]}
    />
  );
};

export default UploadFiles;
